import { render, staticRenderFns } from "./ItemConflict.vue?vue&type=template&id=89ff82ea&scoped=true&"
import script from "./ItemConflict.vue?vue&type=script&lang=js&"
export * from "./ItemConflict.vue?vue&type=script&lang=js&"
import style0 from "./ItemConflict.vue?vue&type=style&index=0&id=89ff82ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ff82ea",
  null
  
)

export default component.exports